

export const globalPopupActions = {
    INIT_GLOBAL_ERROR: 'INIT_GLOBAL_ERROR',
    CLEAR_GLOBAL_ERROR: 'CLEAR_GLOBAL_ERROR'
}

